import { motion } from "framer-motion";
import { fadeIn } from "../utils/motion";
import SectionWrapper from "../hoc/SectionWrapper";
import { Link } from "react-router-dom";
import { SVGS } from "../components";
const SuccessPaymentPage = () => {
  return (
    <div className="max-w-full sm:max-w-xl md:max-w-2xl lg:max-w-6xl xl:max-w-[85rem] mx-auto">
      <motion.div
        variants={fadeIn("up", "tween", 0.1, 0.5)}
        className="flex-[0.75] bg-black-100 rounded-2xl"
      >
        <div className="grid grid-cols-1 lg:grid-cols-7 gap-x-5 lg:gap-x-8 xl:gap-x-12 items-center">
          <div className="col-span-1 lg:col-span-4">
            <h1 className="text-3xl font-bold text-gray-800 sm:text-4xl md:text-5xl lg:text-6xl  ">
              Hvala na povjerenju
            </h1>
            <p className="mt-3 text-lg text-gray-800  ">
              Vasa pozivnica je aktivirana. Mozete je dodatno urediti,
              pregledati i provjeriti uzvanike na{" "}
              <Link className="text-blue-500" to="/moje-pozivnice">
                {" "}
                Moje pozivnice{" "}
              </Link>
            </p>
          </div>
          <div className="col-span-1 lg:col-span-3 mt-10 lg:mt-0 overflow-hidden ">
            <SVGS.SuccessPaymentSVG />,
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default SectionWrapper(SuccessPaymentPage, "");
